import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

// Function to convert text to PascalCase
const pascalCase = (text) => text.replace(/\b\w/g, (match) => match.toUpperCase());

PascalCaseTextField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    defaultValue: PropTypes.string,
};

export default function PascalCaseTextField({ name, helperText, defaultValue, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    {...field}
                    fullWidth
                    value={typeof field.value === 'number' && field.value === 0 ? '' : pascalCase(field.value)}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    inputProps={{ autoComplete: 'off' }}
                    {...other}
                />
            )}
        />
    );
}
